import React from 'react'
import cx from 'classnames'

import { Loader } from 'components/shared/Loader/Loader'
import { ListItem } from './common/ListItem/ListItem'

import styles from './InfiniteScroll.module.scss'

type InfiniteScrollProps = {
  children?: React.ReactNode
  className?: string
  tagName?: React.ElementType
  isPending?: boolean
}

export const InfiniteScroll = ({
  children,
  className,
  tagName,
  isPending,
}: InfiniteScrollProps) => {
  const Element = tagName ?? 'menu'

  return (
    <Element className={cx(styles.list, className)}>
      {children}
      {isPending ? (
        <ListItem className={styles.loader}>
          <Loader isInline />
        </ListItem>
      ) : null}
    </Element>
  )
}

InfiniteScroll.Item = ListItem
